import { useEffect } from 'react';

import { useDispatch } from 'react-redux';
import { checkEnableCompanySupport } from 'utils/helpers/featureFlags';

import {
  CompaniesMapType,
  setDisciplinaryActionAllCompanies,
  setDisciplinaryActionAllLocations,
  setDisciplinaryActionSelectedCompanies,
  setDisciplinaryActionSelectedLocations,
} from '../slice/DisciplinaryActionsIntentSlice';

// NOT A DESCRIPTIVE TYPE
type Row = {
  LOCATION: string;
  COMPANY: null | { id: number; companyName: string };
};

export const useSetDisciplinaryActionMetaFiltersInitialData = (disciplinaryActionsGridData: { rows: Row[] }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const rowData = disciplinaryActionsGridData?.rows || [];
    if (checkEnableCompanySupport() && rowData.length > 0) {
      const companiesMap = {};
      const locationsMap = {};

      rowData.forEach((row) => {
        // Company data extraction
        const companyId = row?.COMPANY?.id;
        if (companyId && !companiesMap[companyId]) {
          companiesMap[companyId] = row.COMPANY;
        }

        // Location data extraction
        const location = row?.LOCATION;
        if (location && !locationsMap[location.toLowerCase()]) {
          locationsMap[location.toLowerCase()] = location;
        }
      });

      // Format and dispatch company data
      const formattedCompanies = Object.values(companiesMap) as CompaniesMapType;
      dispatch(setDisciplinaryActionAllCompanies(formattedCompanies));
      dispatch(setDisciplinaryActionSelectedCompanies(formattedCompanies));

      // Format and dispatch location data
      const formattedLocations = Object.values(locationsMap) as string[];
      dispatch(setDisciplinaryActionAllLocations(formattedLocations));
      dispatch(setDisciplinaryActionSelectedLocations(formattedLocations));
    }
    // Reset filters if company support is disabled or no data
    else {
      dispatch(setDisciplinaryActionAllCompanies([]));
      dispatch(setDisciplinaryActionSelectedCompanies([]));
      dispatch(setDisciplinaryActionAllLocations([]));
      dispatch(setDisciplinaryActionSelectedLocations([]));
    }
  }, [dispatch, disciplinaryActionsGridData?.rows]);
};
